import axios from 'axios'

import { DocumentTypes, DraftInterface } from '../Interfaces/Draft/DraftInterface'
import { EstimateInterface } from '../Interfaces/Invoice/InvoiceInterface'
import { getDocument } from './document'
import { getRequestConfig } from './index'

interface EstimateCount {
  total: number
}

export async function saveEstimate(estimate: DraftInterface) {
  const url = `rest-invoice/api/estimates/${estimate.id}`
  delete estimate.id
  const response = await axios.put(url, estimate, getRequestConfig())
  return response.data
}

export async function getEstimate(id: number): Promise<EstimateInterface> {
  return getDocument(DocumentTypes.ESTIMATE, id)
}

export async function setEstimateStatus(estimateId: number, statusType: string) {
  const url = `/rest-invoice/api/estimates/${estimateId}/event/${statusType}`
  return axios.post(url, null, getRequestConfig())
}

export async function getEstimateCount() {
  const url = '/rest-invoice/api/estimates/count'
  const response = await axios.get(url, getRequestConfig())
  return response.data as EstimateCount
}
